import React from 'react';
import { useHistory } from 'react-router';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';

// Hooks
import { useUserSuggestion } from 'Shared/utils/hooks/use-user-suggestion';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Components
import BaseUserSuggestionItem from './BaseUserSuggestionItem';

type Props = {
  userSuggestion: UserSuggestion;
  className?: string;
};

const PrepareForMeetingSuggestion = ({ userSuggestion, className }: Props) => {
  const history = useHistory();
  const { handleUpdateCompletedAt } = useUserSuggestion({ userSuggestion });

  const handleOnClick = () => {
    handleUpdateCompletedAt();
    history.push(PageUrlsUtils.makeWorkspaceUrl(userSuggestion.suggestablePublicId));
  };

  return (
    <BaseUserSuggestionItem
      userSuggestion={userSuggestion}
      btnLabel="View Agenda"
      onClick={handleOnClick}
      className={className}
    />
  );
};

export default PrepareForMeetingSuggestion;
